import { detect } from 'detect-browser'

export const timeToBarIndex = (time: number, barPositions?: Array<number> | null | undefined): number => {
  if (!barPositions) {
    return 0
  }

  let i = 0
  while (i <= barPositions.length && barPositions[i] < time) {
    i += 1
  }
  return Math.max(0, i - 1)
}

export const isLoopPlayerSupportedBrowser = (): boolean => {
  const browser = detect()
  const majorVersion = browser?.version.split('.')[0]
  const isSupported = !(['ios', 'safari'].includes(browser?.name) && majorVersion < 13)
  return isSupported
}
